import { PropsWithChildren } from "react";

import { makeSvgDataSrc } from "../../Advertisement/helper/makeSvgData";

function createVideoPlaceholder(unitId: string): React.FC<PropsWithChildren> {
  const Component = ({ children }: PropsWithChildren) => (
    <div data-placeholder={unitId}>
      <div>
        <img
          style={{ maxWidth: "100%" }}
          src={makeSvgDataSrc({
            width: 857,
            height: 482,
            text: `VideoPlaceholder: ${unitId}`,
          })}
          alt={`VideoPlaceholder-${unitId}`}
        />
      </div>
      {children}
    </div>
  );

  Component.displayName = `VideoPlaceholder-${unitId}`;
  return Component;
}

export const VideoPlaceholder = createVideoPlaceholder("landscape");
